import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { AdminService } from '../../services/admin'; // Importa tu AdminService
import { Route } from '../../../../shared/models/route'; // Importa la interfaz Route
import { RouteFormData } from '../../../../shared/models/route-form-data'; // Importa la interfaz RouteFormData
import { RouteForm } from '../route-form/route-form';
import { PermissionService } from '../../../../core/authorization/permission';
import { Observable, of } from 'rxjs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-routes',
  standalone: true,
  imports: [CommonModule, MatTableModule, MatButtonModule, MatIconModule, MatSortModule, MatPaginatorModule, MatFormFieldModule, MatInputModule, FormsModule],
  templateUrl: './routes.html',
  styleUrl: './routes.css'
})
export class RoutesComponent implements OnInit, AfterViewInit {
	dataSource       : MatTableDataSource<Route> = new MatTableDataSource<Route>([]);
    displayedColumns : string[]     = ['name', 'status', 'createdAt', 'actions'];
	canCreateRoute$   : Observable<boolean>;
	canEditRoute$     : Observable<boolean>;
	canDeleteRoute$   : Observable<boolean>;

    @ViewChild(MatSort) sort!: MatSort;

    @ViewChild(MatPaginator) paginator!: MatPaginator;

    constructor(private adminService: AdminService, private dialog: MatDialog, private permissionService: PermissionService) {
        this.canCreateRoute$ = this.permissionService.hasPermission('routes.create');
        this.canEditRoute$   = this.permissionService.hasPermission('routes.update');
        this.canDeleteRoute$ = of(false);

        this.dataSource.filterPredicate = (data: Route, filter: string) => {
            const searchString = filter.trim().toLowerCase();
            const nameMatch    = data.name.toLowerCase().includes(searchString);
        
            return nameMatch;
        };
    }

    ngOnInit(): void {
        this.loadRoutes();
    }

    ngAfterViewInit(): void {
        this.dataSource.sort      = this.sort;
        this.dataSource.paginator = this.paginator;
    }

    async loadRoutes(): Promise<void> {
        const result = await this.adminService.getAllRoutes();

		if(result) {
            this.dataSource.data = result;
        }
    }

    applyFilter(event: Event): void {
		const filterValue = (event.target as HTMLInputElement).value;
		this.dataSource.filter = filterValue.trim().toLowerCase();

		if(this.dataSource.paginator) {
			this.dataSource.paginator.firstPage();
		}
	}

    async onCreateRoute(): Promise<void> {
        const dialogRef = this.dialog.open(RouteForm, {
			width: '600px',
			disableClose: true,
			data: null
        });

        dialogRef.afterClosed().subscribe(async (result: RouteFormData | undefined) => {
            if(result) {
                const success = await this.adminService.createRoute({
					name     : result.name,
					status   : result.status
                });

                if(success) {
                    this.loadRoutes();
                }
            }
        });
    }

    async onEditRoute(route: Route): Promise<void> {
        const formData: RouteFormData = {
            id     : route.id,
            name   : route.name,
            status : route.status
        };

        const dialogRef = this.dialog.open(RouteForm, {
			width: '600px',
			disableClose: true,
			data: formData
        });

        dialogRef.afterClosed().subscribe(async (result: RouteFormData | undefined) => {
            if(result) {
                const routeId = result.id;
                
                const updatePayload: Partial<Omit<RouteFormData, 'id'>> = {
                    name    : result.name,
                    status  : result.status
                };

                const success = await this.adminService.updateRoute(routeId!, updatePayload);

                if(success) {
                    this.loadRoutes();
                }
            }
        });
    }

    async onDeleteRoute(id: string): Promise<void> {
        if(window.confirm('¿Estás seguro de que quieres eliminar esta ruta? Esta acción es irreversible.')) {
            const success = await this.adminService.deleteRoute(id);

            if(success) {
                this.loadRoutes();
            }
        }
    }
}
